import classNames from 'classnames';
import RatingStar from 'components/common/RatingStar';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent, useMemo } from 'react';
import { dateService } from 'services/DateService';
import { CommentAnswer } from 'types/vehicle.type';

interface VehicleDetailCommentsItemProps {
  commentor: string;
  comment: string;
  title: string;
  rating: number;
  commentDate: string;
  answer?: CommentAnswer;
  className?: string;
}

const VehicleDetailCommentsItem: FunctionComponent<
  VehicleDetailCommentsItemProps
> = ({ commentor, comment, rating, commentDate, className, title, answer }) => {
  const { t } = useTranslation('vehicle');
  const formattedDate = useMemo(
    () => dateService.getReadableDate(commentDate),
    [commentDate]
  );

  const baseLayout = 'flex-col-reverse items-start';
  const smLayout = 'sm:flex-row sm:items-center';
  const mdLayout = 'md:flex-col-reverse md:items-start';
  const lgLayout = 'lg:flex-row lg:items-center';

  return (
    <div className={classNames('flex w-full gap-4', className)}>
      <div className="w-full">
        <div
          className={classNames(
            'flex w-full justify-between',
            baseLayout,
            smLayout,
            mdLayout,
            lgLayout
          )}
        >
          <div className="flex items-center gap-2">
            <span className="inline-block">{commentor}</span>
            <RatingStar rating={rating} hideCommentCount />
          </div>
          <span className="inline-block text-sm text-slate-500">
            {formattedDate}
          </span>
        </div>
        <div className="mt-2">
          <span className="inline-block font-medium">{title}</span>
        </div>
        <div className="mt-2">
          <span className="inline-block text-sm">{comment}</span>
        </div>
        {answer ? (
          <div className="mt-2 p-2">
            <div className="flex justify-between text-slate-500">
              <span>{t('partnerAnswer')}</span>
              <span className="text-sm">
                {dateService.getReadableDate(
                  dateService.formatServerDateToLocalDate(answer.createdAt)
                )}
              </span>
            </div>
            <div className="font-medium">{answer.title}</div>
            <div className="text-sm">{answer.content}</div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default VehicleDetailCommentsItem;
